module.exports = __webpack_public_path__ + "static/media/4.3a6d4a3f.jpg";